import { IconButton, type IconButtonProps, Tooltip, useTheme } from "@mui/material";

interface BorderedIconButtonProps extends IconButtonProps {
  tooltip?: string;
}

export function BorderedIconButton(props: BorderedIconButtonProps) {
  const { children, tooltip, ...restProps } = props;
  const theme = useTheme();
  return (
    <Tooltip title={tooltip}>
      <IconButton
        sx={{
          border: `1px solid ${theme.palette.divider}`,
          borderRadius: 1,
          backgroundColor: theme.palette.background.default,
          padding: 0.5,
          color: theme.palette.primary.main,
        }}
        {...restProps}
      >
        {children}
      </IconButton>
    </Tooltip>
  );
}
